import React, { lazy, useRef, useState } from 'react';
import { pageUrls } from 'globalconfig/constants/keys';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import { useLocation, useParams } from 'react-router-dom';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const Payment = lazy(() => import(`globalcomponents/Payment/${layout}`));

const TopActions = ({ i18n, updateCard, callback, Styled, history, updateCardDetails }) => {
  const SERVICE_PROVIDER = window.$environment?.SERVICE_PROVIDER;
  const isInsurancePortalUser = isInsuracePortalUser();
  const policyHolderAddURL = '/policyholders/add';

  const [open, setOpen] = useState(false);
  const [ModalListObject, setModalListObject] = useState({});
  const paymentRef = useRef();
  const params = useParams();
  const location = useLocation();

  const cardDetails = (data) => {
    updateCardDetails({
      apiId: 'updateCardDetails',
      data: {
        cardHolderName: data.cardHolderName,
        stripeToken: data.stripeToken,
      },
      callback: callback,
      history: history,
      i18n: i18n,
    });
    setOpen(false);
  };

  return (
    <Styled.Wrapper>
      <FormStyle.ButtonsWrapper className="creditCardWrapper">
        {checkServiceProvider('topaction_payment_button', SERVICE_PROVIDER, false) &&
          location.pathname !== policyHolderAddURL &&
          !isInsurancePortalUser && (
            <Button
              id="creditCardUpdate"
              type="submit"
              label={i18n.t('companyData.updateCreditCardDetails')}
              onClick={() => {
                setModalListObject({
                  content: () => {
                    return (
                      <>
                        <Payment
                          getEmail
                          ref={paymentRef}
                          buttonLabel={'Update Credit Card Details'}
                          validationMessage={i18n.t('common.fieldRequiredMessage')}
                          updateCard={(data) => cardDetails(data)}
                          handleOnChange={(event, type) => { }}
                          validationMessageMail={i18n.t('common.emailValidationMessage')}
                          hidepaymentButton
                        />
                        <div className="deletebtn companyDataCard">
                          <Button
                            label={checkServiceProvider('topaction_pay_btn_label', SERVICE_PROVIDER, false)}
                            onClick={() => {
                              paymentRef.current && paymentRef.current.handleSubmit(() => { });
                            }}
                          ></Button>
                        </div>
                      </>
                    );
                  },
                });
                setOpen(true);
              }}
            />
          )}
        {checkServiceProvider('topaction_button_update_card', SERVICE_PROVIDER, false) ? (
          <Button
            id="creditCardUpdate"
            type="submit"
            label={i18n.t('companyData.updateCardDetails')}
            onClick={() => {
              updateCard({
                updateId: 'updateCard',
                callback: callback,
              });
            }}
          />
        ) : checkServiceProvider('topaction_button', SERVICE_PROVIDER, false, {
          condition: location.pathname !== policyHolderAddURL,
        }) ? (
          <Button
            id="creditCardUpdate"
            type="submit"
            label={i18n.t('companyData.paymentInformation')}
            onClick={() => {
              history.push(`${pageUrls.paymentInformation}${isInsurancePortalUser && params ? `?companyId=${params?.id}` : ``}`);
            }}
          />
        ) : null}

        {checkServiceProvider('topaction_button_update_card', SERVICE_PROVIDER, false)
          ?(checkServiceProvider('topaction_button', SERVICE_PROVIDER, false, {condition: location.pathname !== policyHolderAddURL,
          }) &&
            <Button
              id="creditCardUpdate"
              type="submit"
              label={i18n.t('companyData.paymentInformation')}
              onClick={() => {
                history.push(`${pageUrls.paymentInformation}${isInsurancePortalUser && params ? `?companyId=${params?.id}` : ``}`);
              }}
            />
          ) : null}
      </FormStyle.ButtonsWrapper>
      <Modal.default open={open} setOpen={setOpen} data={ModalListObject} withCloseIcon alignItemsLeft companyData width={720} />
    </Styled.Wrapper>
  );
};
export default TopActions;
